import type { CompanyBankTransferRepository } from "../../../domain/repositories/company/company-bank-transfer-repository";
import type {
  BankTransferEntity,
  CreateBankTransferCommand,
  UpdateBankTransferCommand,
} from "../../../domain/types/company-bank-transfer";
import { BankTransferEntitySchema } from "../../../domain/types/company-bank-transfer";
import { companyBankTransferApiService } from "../../api/company/company-bank-transfer-api-service";
import { z } from "zod";

export class CompanyBankTransferRepositoryImpl
  implements CompanyBankTransferRepository
{
  async createBankTransfer(
    companyId: number,
    request: CreateBankTransferCommand,
  ): Promise<BankTransferEntity> {
    const response = await companyBankTransferApiService.createBankTransfer(
      companyId,
      request,
    );

    if (response.data) {
      return BankTransferEntitySchema.parse(response.data);
    }

    throw new Error(response.errorMsg || "무통장 정보 생성 실패.");
  }

  async deleteBankTransfer(
    companyId: number,
    bankTransferId: number,
  ): Promise<boolean> {
    const response = await companyBankTransferApiService.deleteBankTransfer(
      companyId,
      bankTransferId,
    );

    if (response.data) {
      // validate boolean type
      return z.boolean().parse(response.data);
    }

    throw new Error(response.errorMsg || "무통장 정보 삭제 실패.");
  }

  async getBankTransfer(companyId: number): Promise<BankTransferEntity[]> {
    const response =
      await companyBankTransferApiService.getBankTransfer(companyId);

    if (response.data) {
      return z.array(BankTransferEntitySchema).parse(response.data);
    }

    throw new Error(response.errorMsg || "무통장 정보 받기 실패.");
  }

  async updateBankTransfer(
    companyId: number,
    bankTransferId: number,
    command: UpdateBankTransferCommand,
  ): Promise<BankTransferEntity> {
    const response = await companyBankTransferApiService.updateBankTransfer(
      companyId,
      bankTransferId,
      command,
    );

    if (response.data) {
      return BankTransferEntitySchema.parse(response.data);
    }

    throw new Error(response.errorMsg || "무통장 정보 업데이트 실패.");
  }
}
